import {
	array,
	arrayMinMax,
	boolean,
	defaultObject,
	enumValues,
	language,
	literal,
	nullable,
	object,
	string,
} from "../../../types/_types";

import articleDeliveryTypes from "../../articles/constants/articleDeliveryTypes";
import { articleType } from "../../articles/types/Article";
import { ArticlePrice } from "../../articles/types/ArticlePrice";

import { DistributionChannelRef } from "./DistributionChannelRef";

export const DistributionPreset = object({
	id: string(),
	articleType: articleType,
	languages: arrayMinMax(language().or(literal("all")), 1),
	imprintIds: array(string()),
	channel: DistributionChannelRef,
	deliveryTypes: array(enumValues(articleDeliveryTypes)),
	targetData: defaultObject({
		countries: array(string()),
		prices: array(ArticlePrice),
		subChannels: nullable(array(object({ id: string(), name: string() }))),
	}),
	disabled: boolean(false),
});
